<template>
  <div>
    <div style="height:40px;"></div>
    <a-tabs class="parent-tabs" default-active-key="1" type="card" size="large" style="margin: 20px 10px 0px 10px;height: 640px;">
      <a-tab-pane key="1" tab="Differential expression" style="margin-top: 10px;">
        <differential-expression></differential-expression>
      </a-tab-pane>
      <a-tab-pane key="2" tab="Single gene expression" style="margin-top: 10px;">
        <single-gene-expression></single-gene-expression>
      </a-tab-pane>
      <a-tab-pane key="3" tab="GO_KEGG" style="margin-top: 10px;">
        <go-kegg></go-kegg>
      </a-tab-pane>
      <a-tab-pane key="6" tab="PPI network" style="margin-top: 20px;">
        <protein-protein></protein-protein>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
  
<script>
import DifferentialExpression from '@/components/LacAnalysis/DifferentialExpression.vue';
import SingleGeneExpression from '@/components/LacAnalysis/SingleGeneExpression.vue';
import GoKegg from '@/components/LacAnalysis/GoKegg.vue';
import ProteinProtein from '@/components/LacAnalysis/ProteinProtein.vue';

  export default {
    name: 'LacAnalysis',
  components: {
    DifferentialExpression,
    SingleGeneExpression,
    GoKegg,
    ProteinProtein,
  },
    data() {
    return {
    };
  },
    methods: {
    },
  };
  </script>
  
<style scoped>
.code-box-demo .ant-slider {
  margin-bottom: 16px;
}
</style>
